import React, {forwardRef} from "react";
import {useTranslation} from "react-i18next";
import cn from "classnames";
import {Preloader} from "../Preloader";
import {CustomTooltip} from "components/CustomTooltip";

export const ButtonTransparent = forwardRef((props, ref) => {
  const {
    name,
    additionalName,
    type,
    onClick,
    onIconClick,
    img,
    icon,
    imgRight,
    iconRight,
    addClass,
    disabled,
    loading,
    style,
    nonTransparent,
    large,
    medium,
    small,
    tiny,
    noBorder,
    rounded,
    circular,
    uppercase,
    bold,
    color,
    fullWidth,
    hoverable,
    hoverableLink,
    clickable,
    nowrap,
    disabledTransparent,
    showOnHover,
    iconButton,
    tooltip,
    disabledTooltip,
    tooltipPlacement,
  } = props;

  const {t} = useTranslation();

  // must not be a component declared in render: a new type on every render would
  // remount the icons, and a remount between mousedown and mouseup swallows the click
  const withIconClick = (children) =>
    onIconClick ? (
      <div className="df cpointer" onClick={onIconClick}>
        {children}
      </div>
    ) : (
      children
    );

  const commonButton = (
    <React.Fragment>
      {(img || icon) && withIconClick((img && <img src={img} alt="" />) || icon)}
      {!!(name || additionalName) && (
        <span>
          {t(name)} {additionalName}
        </span>
      )}
      {(imgRight || iconRight) &&
        withIconClick((imgRight && <img src={imgRight} alt="" />) || iconRight)}
    </React.Fragment>
  );

  return (
    <button
      className={cn(
        "btn-custom_main btn-transparent",
        {"__full-bg": nonTransparent},
        {"__disabled-off-bg": disabledTransparent},
        {"__center-loader": loading},
        {__large: large},
        {__medium: medium},
        {__small: small},
        {__tiny: tiny},
        {__rounded: rounded},
        {__circular: circular},
        {__uppercase: uppercase},
        {__bold: bold},
        {[`__${color}`]: !!color},
        {"__non-clickable": !(!!onClick || type === "submit" || clickable)},
        {"__full-width": fullWidth},
        {"__no-border": noBorder},
        {"__show-on-hover": showOnHover},
        {__hoverable: !!hoverable && !disabled},
        {"__hoverable-link": !!hoverableLink},
        {"__icon-button": iconButton},
        {"__no-wrap": !!nowrap},
        {"__image-right": imgRight || iconRight},
        {"pl-1": !loading && (img || icon) && !addClass?.includes("pl-") && !showOnHover},
        {[addClass]: !!addClass}
      )}
      onClick={onClick}
      style={style}
      type={type || "button"}
      disabled={disabled || loading}
      ref={ref}
    >
      {loading ? (
        <Preloader size={small || tiny ? "small" : "default"} />
      ) : tooltip ? (
        <CustomTooltip text={tooltip} placement={tooltipPlacement}>
          <span style={{height: "inherit"}} className="df-row-center">
            {commonButton}
          </span>
        </CustomTooltip>
      ) : disabledTooltip && disabled ? (
        <CustomTooltip text={disabledTooltip} placement={tooltipPlacement}>
          <span style={{height: "inherit"}} className="df-row-center">
            {commonButton}
          </span>
        </CustomTooltip>
      ) : (
        commonButton
      )}
    </button>
  );
});
